<template>
<div>
 <el-container>
    <el-main>
    <div
        lang="en"
        v-loading="loading"
        element-loading-text="Logging in..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0.0, 0.0, 0.0, 0.0)"
    >
        <img src="../../public/logo.png" alt="logo" style="width: 100%">
        <el-form label-position="left" label-width="90px" ref="form" :model="form" size="medium">
            <el-form-item label="Email">
                <el-input
                    v-model="form.email"
                ></el-input>
            </el-form-item>
            <el-form-item label="Password">
                <el-input
                    v-model="form.password"
                    show-password
                ></el-input>
            </el-form-item>
            <div>
                <el-link @click="forgotPasswordVisible=true" class="forgot-password">Forgot password</el-link>
                <el-link @click="signUp" class="sign-up">Sign up</el-link>
            </div>
            <div
                style="text-align: center; margin: 30px 0 0 0; display: inline;"
            >
                <el-form-item>
                    <el-button @click="onClose" size="small">Cancel</el-button>
                    <el-button type="primary" @click="submitForm('form')"
                        >Sign In</el-button
                    >
                </el-form-item>
            </div>
        </el-form>
        </div>
        </el-main>
         </el-container>
        <div>
        <el-dialog :visible.sync="forgotPasswordVisible" width="35%"  append-to-body>
        <span slot="title" class="email">Email</span>
        <div>
          <el-form v-loading="sendEmailLoading"
        element-loading-text="Please wait..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0.0, 0.0, 0.0, 0.0)" @submit.prevent.native="sendEmail">
            <el-input v-model="email"></el-input>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="forgotPasswordVisible = false"
            >Cancel</el-button
          >
          <el-button type="primary" @click="sendEmail">Confirm</el-button>
        </span>
    </el-dialog>
    </div>
    </div>
</template>

<script>
import { showMessage } from '../utils';
import { Auth } from 'aws-amplify';
import 'amazon-cognito-identity-js';
import { mapState } from 'vuex';
import 'cross-fetch/polyfill';

export default {
    name: 'AdminLogin',
    data() {
        return {
            forgotPasswordVisible: false,
            email:''
        }
    },
    methods: {
        async submitForm() {
            await this.login();
            this.onClose();
        },
        async login() {
            try {
                this.$store.commit('user/setAuthLoading', true);
                const user = await Auth.signIn(
                    this.form.email.toLowerCase(),
                    this.form.password
                );
                const {
                    idToken,
                    accessToken,
                    refreshToken,
                } = user.signInUserSession;
                const tokens = {
                    idToken: idToken.jwtToken,
                    accessToken: accessToken.jwtToken,
                    refreshToken: refreshToken.token,
                };
                showMessage('Logged in successfully', 'success')
                localStorage.setItem('user', JSON.stringify(tokens));
                this.$store.commit('user/setTokens', tokens);
                this.$store.commit('user/updateLoginStatus', true);
                this.$store.commit('user/setAuthLoading', false);
                this.$router.push({
                    name: "AdminDashboard",
                });
                
            } catch (err) {
                showMessage('Log in failed', 'error')
                this.$store.commit('user/setAuthLoading', false);
            }
        },
        async sendEmail() {
            this.$store.commit('user/setSendEmailLoading', true);
            Auth.forgotPassword(this.email.toLowerCase()).then(() => {
                this.$store.commit('user/setSendEmailLoading', false);
                this.forgotPasswordVisible = false;
                this.email=''
                showMessage('Verification email sent.', 'success')
                }).catch((err) =>{
                    this.$store.commit('user/setSendEmailLoading', false);

                    if(err.name === 'UserNotFoundException'){
                        showMessage('User not found', 'error')
                    } else {
                        showMessage('Something went wrong. Please try again after some time.', 'error')
                    }
                }
            );
        },
        signUp(){
            this.$router.push({
                name: "AdminSignUp", 
            })
        }
    },
    computed: {
        ...mapState({
            form: (state) => state.user.loginForm,
            loading: (state) => state.user.authLoading,
        }),
    },
};
</script>

<style scoped>
.el-main {
    width: 500px;
    min-width: 500px;
    max-width: 500px;
    margin: 55px auto;
}
.forgot-password,.sign-up{
    margin-left: 50px;
    margin-bottom: 40px;
}

.email{
    margin-left:45%;
}

</style>
